module.exports = __webpack_public_path__ + "img/menu.fe6be280.svg";